export interface CategoryArticleItem {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  tag: string;
  image: string;
  date: string;
  views: string;
  author: string;
}

export const categoryInfo: Record<string, { name: string; description: string; icon: string }> = {
  'daily-contest': {
    name: '每日大赛',
    description: '网红塌房黑料不断更，每日最新爆料汇总，吃瓜第一线',
    icon: 'ri-fire-line',
  },
  'celebrity-scandal': {
    name: '网红塌房',
    description: '追踪网红翻车现场，深度揭秘人设崩塌背后的真相',
    icon: 'ri-alert-line',
  },
  'blogger-contrast': {
    name: '博主反差',
    description: '揭开博主滤镜，还原真实面貌，反差内容一网打尽',
    icon: 'ri-contrast-2-line',
  },
  'trending': {
    name: '热门事件',
    description: '全网最热门八卦事件追踪，第一时间掌握吃瓜动态',
    icon: 'ri-flashlight-line',
  },
};

export const categoryArticles: CategoryArticleItem[] = [
  {
    id: 'cat-01',
    title: '顶流网红深夜直播翻车，百万粉丝瞬间脱粉回踩',
    excerpt: '知名带货主播在直播间因不当言论引发全网热议，品牌方连夜解约，账号遭平台限流处理。事件持续发酵，更多内幕被曝光。',
    category: '网红塌房',
    categorySlug: 'celebrity-scandal',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20artistic%20abstract%20composition%20with%20deep%20crimson%20and%20dark%20charcoal%20tones%2C%20fractured%20geometric%20shapes%20suggesting%20digital%20collapse%2C%20moody%20atmospheric%20lighting%20with%20subtle%20golden%20streaks%2C%20contemporary%20editorial%20design%20aesthetic%20for%20entertainment%20news%2C%20high%20contrast%20dramatic%20visual%2C%20dark%20warm%20gradient%20background%20with%20scattered%20luminous%20particles%2C%20cinematic%20quality%2C%20no%20text%20or%20lettering&width=800&height=600&seq=cat-img-01&orientation=landscape',
    date: '2026-07-07',
    views: '3280万',
    author: '吃瓜前线',
  },
  {
    id: 'cat-02',
    title: '年度最大反转！曾被群嘲的博主晒出证据链打脸全网',
    excerpt: '沉寂半年的美食博主放出完整聊天记录与转账凭证，剧情反转引发二次吃瓜热潮。网友纷纷表示"这次是我错了"。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    tag: '热',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20digital%20artwork%20with%20warm%20amber%20and%20deep%20burgundy%20colors%2C%20overlapping%20translucent%20layers%20creating%20depth%20and%20mystery%2C%20dynamic%20flowing%20shapes%20suggesting%20revelation%20and%20truth%20emerging%2C%20modern%20editorial%20style%2C%20soft%20dramatic%20lighting%20with%20warm%20golden%20glow%2C%20rich%20textural%20abstract%20background%2C%20sophisticated%20visual%20narrative%20without%20any%20text&width=800&height=600&seq=cat-img-02&orientation=landscape',
    date: '2026-07-06',
    views: '2580万',
    author: '真相挖掘机',
  },
  {
    id: 'cat-03',
    title: '某千万粉颜值博主真实颜值曝光，滤镜前后判若两人',
    excerpt: '线下活动生图流出，与社交平台精修照差距巨大，网友直呼"诈骗级别"。该博主目前仍未回应。',
    category: '博主反差',
    categorySlug: 'blogger-contrast',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20split%20warm%20coral%20and%20cool%20dark%20tones%2C%20glitch%20effect%20style%20geometric%20disruption%20suggesting%20digital%20manipulation%2C%20contemporary%20editorial%20art%20direction%2C%20dramatic%20contrast%20between%20soft%20pastels%20and%20harsh%20dark%20shadows%2C%20conceptual%20visual%20representing%20duality%20and%20revelation%2C%20no%20text%20visible%2C%20cinematic%20atmospheric%20quality&width=800&height=600&seq=cat-img-03&orientation=landscape',
    date: '2026-07-05',
    views: '4160万',
    author: '素颜鉴定师',
  },
  {
    id: 'cat-04',
    title: '某音千万网红被曝私下辱骂粉丝录音曝光',
    excerpt: '录音长达8分钟，内容令人震惊。粉丝团集体宣布解散，多个品牌方紧急暂停合作。',
    category: '网红塌房',
    categorySlug: 'celebrity-scandal',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20artistic%20still%20life%20with%20warm%20crimson%20and%20shadow%20tones%2C%20single%20dramatic%20spotlight%20effect%20on%20dark%20background%2C%20contemporary%20editorial%20photography%20style%2C%20moody%20and%20mysterious%20atmosphere%2C%20clean%20simple%20composition%2C%20soft%20gradient%20shadows%2C%20sophisticated%20visual%20for%20entertainment%20news%2C%20no%20text%20or%20people&width=800&height=600&seq=cat-img-04&orientation=landscape',
    date: '2026-07-07',
    views: '1890万',
    author: '音频分析师',
  },
  {
    id: 'cat-05',
    title: '两大顶流博主隔空互怼，聊天截图泄露',
    excerpt: '截图内容信息量巨大，涉及多位圈内人士。双方粉丝已在评论区展开激烈交锋。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    tag: '',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20amber%20and%20deep%20charcoal%20colors%2C%20two%20contrasting%20geometric%20forms%20in%20dynamic%20tension%2C%20modern%20editorial%20art%20style%2C%20dramatic%20warm%20lighting%20from%20diagonal%20angle%2C%20sophisticated%20minimalist%20design%2C%20conceptual%20visual%20of%20conflict%20and%20confrontation%2C%20no%20text%20or%20lettering&width=800&height=600&seq=cat-img-05&orientation=landscape',
    date: '2026-07-06',
    views: '1560万',
    author: '聊天记录研究员',
  },
  {
    id: 'cat-06',
    title: '知名情侣博主被曝早已分手，各自新恋情',
    excerpt: '知情人士爆料两人半年前已分手，各自已有新欢。粉丝震惊：那些甜蜜视频全是演的？',
    category: '网红塌房',
    categorySlug: 'celebrity-scandal',
    tag: '热',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20with%20split%20warm%20rose%20and%20cool%20slate%20tones%2C%20fractured%20heart-shaped%20geometric%20suggestion%2C%20contemporary%20editorial%20photography%20aesthetic%2C%20soft%20dramatic%20lighting%20with%20emotional%20depth%2C%20elegant%20minimalist%20composition%2C%20conceptual%20art%20representing%20separation%2C%20no%20text%20or%20people&width=800&height=600&seq=cat-img-06&orientation=landscape',
    date: '2026-07-05',
    views: '2950万',
    author: '情感观察员',
  },
  {
    id: 'cat-07',
    title: '美食博主被前员工曝光使用过期食材',
    excerpt: '前员工晒出多张后厨照片，卫生状况堪忧。该博主回应称"遭人陷害"，已委托律师处理。',
    category: '博主反差',
    categorySlug: 'blogger-contrast',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20artistic%20still%20life%20with%20deep%20burgundy%20and%20shadow%20tones%2C%20dramatic%20single%20light%20source%20creating%20tension%2C%20contemporary%20editorial%20style%2C%20mysterious%20and%20unsettling%20atmosphere%2C%20clean%20composition%20with%20negative%20space%2C%20conceptual%20visual%20for%20revelation%20and%20exposure%2C%20no%20text%20or%20people&width=800&height=600&seq=cat-img-07&orientation=landscape',
    date: '2026-07-04',
    views: '1840万',
    author: '食品安全卫士',
  },
  {
    id: 'cat-08',
    title: '某带货主播涉嫌虚假宣传被市监局立案',
    excerpt: '宣称"七天美白"产品实为普通护肤品，涉及金额巨大。直播间已被暂停，调查正在进行中。',
    category: '网红塌房',
    categorySlug: 'celebrity-scandal',
    tag: '',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20with%20stark%20contrast%20between%20bright%20white%20and%20deep%20crimson%2C%20clean%20geometric%20division%20suggesting%20truth%20versus%20deception%2C%20editorial%20art%20direction%2C%20dramatic%20lighting%20creating%20sharp%20shadows%2C%20sophisticated%20conceptual%20visual%2C%20modern%20and%20bold%20composition%2C%20no%20text%20or%20lettering&width=800&height=600&seq=cat-img-08&orientation=landscape',
    date: '2026-07-03',
    views: '3120万',
    author: '法制观察',
  },
  {
    id: 'cat-09',
    title: '健身博主身材造假，P图前后对比太离谱',
    excerpt: '网友逐帧分析视频，发现多处修图痕迹。健身圈大佬纷纷发声谴责造假行为。',
    category: '博主反差',
    categorySlug: 'blogger-contrast',
    tag: '热',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20with%20split%20composition%20of%20soft%20warm%20tones%20and%20harsh%20dark%20shadows%2C%20glitch-inspired%20geometric%20distortion%2C%20contemporary%20editorial%20photography%20style%2C%20dramatic%20contrast%20suggesting%20before%20and%20after%20transformation%2C%20moody%20atmospheric%20quality%2C%20no%20text%20or%20people%20visible&width=800&height=600&seq=cat-img-09&orientation=landscape',
    date: '2026-07-03',
    views: '1280万',
    author: '健身打假人',
  },
  {
    id: 'cat-10',
    title: '娱乐圈"好男人"人设崩塌，深夜与神秘女子同回酒店',
    excerpt: '狗仔拍到某已婚男星深夜与年轻女子同回酒店，次日才分别离开。经纪公司紧急公关。',
    category: '热门事件',
    categorySlug: 'trending',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20artistic%20composition%20with%20deep%20burgundy%20and%20charcoal%20tones%2C%20blurred%20city%20night%20lights%20creating%20bokeh%20effect%2C%20dramatic%20noir-inspired%20lighting%2C%20contemporary%20editorial%20photography%20aesthetic%2C%20mysterious%20and%20alluring%20atmosphere%2C%20sophisticated%20visual%20for%20entertainment%20gossip%2C%20no%20recognizable%20people%20or%20text&width=800&height=600&seq=cat-img-10&orientation=landscape',
    date: '2026-07-06',
    views: '5280万',
    author: '娱乐圈纪检委',
  },
  {
    id: 'cat-11',
    title: '某带货一哥被税务部门追缴税款及罚款共计2.3亿',
    excerpt: '税务机关公布典型案例，该主播通过隐匿个人收入、虚构业务转换收入性质等方式偷逃税款。',
    category: '网红塌房',
    categorySlug: 'celebrity-scandal',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20with%20stark%20contrast%20of%20bright%20golden%20light%20against%20deep%20shadow%2C%20clean%20geometric%20forms%20suggesting%20financial%20themes%2C%20editorial%20art%20direction%2C%20dramatic%20high-contrast%20lighting%2C%20sophisticated%20and%20serious%20visual%20tone%2C%20warm%20metallic%20accents%20on%20dark%20background%2C%20no%20text%20or%20people&width=800&height=600&seq=cat-img-11&orientation=landscape',
    date: '2026-07-02',
    views: '6890万',
    author: '税务观察员',
  },
  {
    id: 'cat-12',
    title: '网红圈再爆代写丑闻，多位博主文案出自同一团队',
    excerpt: '内部聊天记录曝光，揭露多名知名博主共用代写团队，月费高达数万元。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    tag: '热',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20with%20overlapping%20translucent%20papers%20in%20warm%20cream%20and%20shadow%20tones%2C%20layered%20geometric%20forms%20suggesting%20documentation%2C%20contemporary%20editorial%20style%2C%20soft%20diffused%20lighting%20from%20above%2C%20intellectual%20and%20investigative%20visual%20mood%2C%20no%20text%20or%20people&width=800&height=600&seq=cat-img-12&orientation=landscape',
    date: '2026-07-01',
    views: '970万',
    author: '文案鉴定官',
  },
  {
    id: 'cat-13',
    title: '知名美妆博主被扒学历造假，实际仅为初中学历',
    excerpt: '粉丝通过多渠道核实发现该博主学历信息严重不符，其自称的"生物化学硕士"纯属虚构。',
    category: '博主反差',
    categorySlug: 'blogger-contrast',
    tag: '',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20artistic%20composition%20with%20fractured%20warm%20coral%20tones%20against%20dark%20background%2C%20broken%20geometric%20shapes%20suggesting%20shattered%20facade%2C%20contemporary%20editorial%20photography%20aesthetic%2C%20moody%20atmospheric%20lighting%2C%20conceptual%20visual%20of%20deception%20and%20truth%2C%20no%20text%20or%20people&width=800&height=600&seq=cat-img-13&orientation=landscape',
    date: '2026-06-30',
    views: '2340万',
    author: '学历打假团',
  },
  {
    id: 'cat-14',
    title: '游戏主播代打风波升级，多位顶流被牵连',
    excerpt: '电竞圈代打产业链曝光，涉嫌主播名单持续增加，平台方表示将严肃处理。',
    category: '热门事件',
    categorySlug: 'trending',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20electric%20warm%20coral%20and%20deep%20shadow%20tones%2C%20fragmented%20digital%20geometric%20patterns%20suggesting%20gaming%20aesthetics%2C%20contemporary%20editorial%20style%2C%20dynamic%20diagonal%20composition%20with%20dramatic%20lighting%2C%20futuristic%20yet%20moody%20atmosphere%2C%20no%20text%20or%20recognizable%20characters&width=800&height=600&seq=cat-img-14&orientation=landscape',
    date: '2026-06-29',
    views: '4120万',
    author: '电竞观察家',
  },
  {
    id: 'cat-15',
    title: '某知名歌手直播带货翻车，产品质量遭集体投诉',
    excerpt: '消费者反映购买商品与直播展示严重不符，目前已收到数千条投诉。消协已介入调查。',
    category: '网红塌房',
    categorySlug: 'celebrity-scandal',
    tag: '',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20with%20stark%20warm%20crimson%20and%20cool%20shadow%20contrast%2C%20clean%20geometric%20shapes%20suggesting%20product%20and%20disappointment%2C%20contemporary%20editorial%20photography%20aesthetic%2C%20dramatic%20lighting%20creating%20tension%2C%20sophisticated%20minimalist%20composition%2C%20conceptual%20visual%20of%20consumer%20rights%2C%20no%20text%20or%20people&width=800&height=600&seq=cat-img-15&orientation=landscape',
    date: '2026-06-28',
    views: '1760万',
    author: '消费维权者',
  },
  {
    id: 'cat-16',
    title: '情侣博主分手内幕：男方出轨女粉丝实锤',
    excerpt: '女方发布长文控诉并附大量证据，男方回应称"清者自清"后遭更多爆料人站出来指证。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20fractured%20warm%20rose%20and%20deep%20charcoal%20tones%2C%20broken%20geometric%20heart%20shape%2C%20dramatic%20noir%20lighting%20from%20single%20source%2C%20contemporary%20editorial%20photography%20aesthetic%2C%20emotional%20and%20intense%20visual%20mood%2C%20sophisticated%20visual%20narrative%2C%20no%20text%20or%20people&width=800&height=600&seq=cat-img-16&orientation=landscape',
    date: '2026-06-27',
    views: '3560万',
    author: '感情鉴定师',
  },
  {
    id: 'cat-17',
    title: '时尚博主私服实为品牌方寄送，人设造假遭质疑',
    excerpt: '网友发现该博主晒出的"日常搭配"全部来自品牌方PR包裹，所谓"私服分享"实为商业推广。',
    category: '博主反差',
    categorySlug: 'blogger-contrast',
    tag: '热',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20with%20warm%20amber%20and%20slate%20tones%2C%20overlapping%20translucent%20layers%20suggesting%20fashion%20and%20facade%2C%20contemporary%20editorial%20style%2C%20soft%20diffused%20lighting%20with%20elegant%20minimalism%2C%20sophisticated%20visual%20questioning%20authenticity%2C%20conceptual%20art%20direction%2C%20no%20text%20or%20people&width=800&height=600&seq=cat-img-17&orientation=landscape',
    date: '2026-06-26',
    views: '890万',
    author: '时尚打假',
  },
  {
    id: 'cat-18',
    title: '头部MCN机构被爆压榨签约博主，抽成高达70%',
    excerpt: '多位博主匿名爆料合同细节，高额抽成加霸王条款引发行业热议。MCN回应称"行业惯例"。',
    category: '热门事件',
    categorySlug: 'trending',
    tag: '',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20with%20stark%20warm%20golden%20and%20deep%20shadow%20contrast%2C%20geometric%20chains%20and%20broken%20forms%2C%20contemporary%20editorial%20photography%20aesthetic%2C%20dramatic%20lighting%20suggesting%20corporate%20tension%2C%20sophisticated%20conceptual%20visual%20of%20power%20dynamics%2C%20no%20text%20or%20people&width=800&height=600&seq=cat-img-18&orientation=landscape',
    date: '2026-06-25',
    views: '2450万',
    author: '行业观察者',
  },
  {
    id: 'cat-19',
    title: '某户外主播被指虐待动物，直播画面引众怒',
    excerpt: '直播间画面显示主播对动物做出不当行为，动物保护组织已介入。平台已永久封禁该账号。',
    category: '网红塌房',
    categorySlug: 'celebrity-scandal',
    tag: '爆',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20artistic%20composition%20with%20deep%20crimson%20and%20shadow%20tones%2C%20fractured%20organic%20geometric%20shapes%20suggesting%20distress%2C%20harsh%20contrast%20lighting%20creating%20tension%2C%20contemporary%20editorial%20photography%20aesthetic%2C%20emotional%20and%20intense%20visual%20mood%2C%20conceptual%20art%20direction%2C%20no%20text%20or%20recognizable%20creatures&width=800&height=600&seq=cat-img-19&orientation=landscape',
    date: '2026-06-24',
    views: '5100万',
    author: '动物保护前线',
  },
  {
    id: 'cat-20',
    title: '科技博主测评数据造假，被同行实锤打脸',
    excerpt: '某百万粉科技博主评测数据与实际产品表现严重不符，多位同行联合发布对比测试结果。',
    category: '博主反差',
    categorySlug: 'blogger-contrast',
    tag: '',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20with%20split%20composition%20of%20warm%20metallic%20amber%20and%20cool%20dark%20slate%2C%20clean%20geometric%20precision%20contrasting%20with%20fractured%20distortion%2C%20contemporary%20editorial%20style%2C%20dramatic%20lighting%20suggesting%20scientific%20accuracy%20versus%20manipulation%2C%20sophisticated%20visual%20concept%2C%20no%20text%20or%20people&width=800&height=600&seq=cat-img-20&orientation=landscape',
    date: '2026-06-23',
    views: '1340万',
    author: '数码打假',
  },
];